module.exports = __webpack_public_path__ + "img/downloadAn.67a0d60d.png";